const focusKeywords = [
  "经纪公司重组",
  "暑期档口碑",
  "剧组路透澄清",
  "演唱会售票机制",
  "标题党治理",
  "音乐节阵容",
  "综艺剪辑争议",
  "名誉维权进展",
  "影视基地探班",
  "夜经济升温",
];

export default function FocusStrip() {
  const loop = [...focusKeywords, ...focusKeywords];

  return (
    <section className="w-full border-y border-background-200 bg-background-100" aria-label="今日聚焦关键词">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-4 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded bg-accent-500 px-2.5 py-1 font-label text-xs font-medium text-background-50">
          <i className="ri-focus-3-line" aria-hidden="true"></i>
          今日聚焦
        </span>
        <div className="no-scrollbar relative flex-1 overflow-hidden">
          <div className="marquee-track whitespace-nowrap">
            {loop.map((keyword, index) => (
              <span key={`${keyword}-${index}`} className="mx-4 inline-flex items-center gap-2 font-label text-sm text-foreground-700">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-400"></span>
                {keyword}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}